import Form from '../../views/Prova/Form';
import { __ADMINISTRADOR, __CENTRAL } from '../../security/RoleConfiguration';

export const path = '/admin/candidatos';

export const listRoutes = [
    {
        path: `${path}/:id/prova/adicionar`,
        component: Form,
        roles: [ __ADMINISTRADOR, __CENTRAL],
    },
]

export default listRoutes;